function activeSearch(){$(".desk-search_wrap").addClass("active")}$(document).ready(function(){var i;$(window).width()<576&&activeSearch(),$(".temp___faq .footer-link li").click(function(){var i=$(this).find("a").attr("href").split("#"),i=i[i.length-1];$(".accordion li #"+i).click()}),$(window).width()<767&&$(".menu-footer li").click(function(){var i=$(this).find("a").attr("href").split("#"),i=i[i.length-1];$(".accordion li #"+i).click()}),0<$(".accordion li").length&&(i=(i=$(location).attr("href").split("#"))[i.length-1],$(".accordion li #"+i).click()),$(".form_success_inner a").click(function(){window.location.href="/pages/contact"}),$(window).width()<767&&$(".menu-footer li").click(function(){$(".close-btn").trigger("click")}),$(".cus_input_border").css({color:"red"})}),$(window).resize(function(){$(window).width()<576&&activeSearch()});

/* ==========================================================================
   The Timeline  —  sections/timeline.liquid
   Scroll reveal + rail progress + rail navigation.

   custom.js is loaded before <body> (layout/theme.liquid), so everything
   waits on DOMContentLoaded. The theme ships no animation library — the
   data-aos attributes on the older sections are dead markup — so this is
   self-contained.

   The rail follows the Ralph Lauren heritage timeline the client asked us to
   match: exactly one dot lit at a time, the lit dot being the event nearest
   the middle of the screen, and clicking a dot centring that event.
   ========================================================================== */

(function () {
  'use strict';

  function initTimeline(root) {
    if (!root || root.dataset.aoTimelineReady === 'true') return;
    root.dataset.aoTimelineReady = 'true';

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Only opt into the hidden-then-revealed state once we know we can undo it.
    root.classList.add('ao-tl--js');

    var pending = Array.prototype.slice.call(root.querySelectorAll('.ao-tl-reveal'));
    var rail = root.querySelector('[data-ao-rail]');
    var dots = rail
      ? Array.prototype.slice.call(rail.querySelectorAll('[data-ao-rail-dot]'))
      : [];
    var events = Array.prototype.slice.call(root.querySelectorAll('[data-ao-event]'));
    var current = -1;
    var railShown = null;

    if (reduceMotion) {
      pending.forEach(function (el) {
        el.classList.add('is-visible');
      });
      pending = [];
    }

    /* --- Reveal ---------------------------------------------------------- */

    // Deliberately scroll-driven rather than IntersectionObserver: IO only
    // fires when an element's intersection state *changes*, so a jump (anchor
    // link, restored scroll position, fast flick) leaves everything that was
    // skipped over stranded at opacity 0 — it never transitions from "below
    // the viewport" to "intersecting", it goes straight to "above" it.
    function updateReveal() {
      if (!pending.length) return;
      var limit = window.innerHeight * 0.88;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top >= limit) return true;
        el.classList.add('is-visible');
        return false;
      });
    }

    /* --- Rail progress --------------------------------------------------- */

    // The collage is what the eye reads as "the section", so it is what the
    // dot should track — not the block box, which starts 200px higher at the
    // top of the year.
    function refFor(event) {
      return event.querySelector('.ao-tl__event-media') || event;
    }

    function setActive(index) {
      if (index === current) return;
      current = index;
      for (var i = 0; i < dots.length; i++) {
        // One at a time. Lighting everything up to the current dot turned the
        // scale into a progress bar, which is not what it is.
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    // Nearest to the middle of the viewport, rather than "the last one whose
    // top has passed halfway". With 345-700px between blocks the two differ by
    // most of a screen, and only the first agrees with what you are looking at.
    function nearestEvent() {
      var middle = window.innerHeight * 0.5;
      var best = -1;
      var bestDistance = Infinity;
      for (var i = 0; i < events.length; i++) {
        var box = refFor(events[i]).getBoundingClientRect();
        var distance = Math.abs(box.top + box.height / 2 - middle);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }
      return best;
    }

    function updateRail() {
      if (!dots.length || !events.length) return;
      setActive(nearestEvent());

      // Fade the rail in once the blocks are actually on screen and out again
      // past the last one, so it never floats over the hero or the footer.
      var track = root.querySelector('.ao-tl__track');
      if (!track) return;
      var box = track.getBoundingClientRect();
      var inside = box.top < window.innerHeight * 0.5 && box.bottom > window.innerHeight * 0.5;
      if (inside !== railShown) {
        railShown = inside;
        rail.classList.toggle('is-in', inside);
      }
    }

    /* --- Rail navigation ------------------------------------------------- */

    function scrollToEvent(index) {
      var event = events[index];
      if (!event) return;
      var box = refFor(event).getBoundingClientRect();
      var target = window.pageYOffset + box.top + box.height / 2 - window.innerHeight / 2;
      window.scrollTo({
        top: Math.max(0, target),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      // Light the target immediately. Smooth scrolling takes long enough that
      // waiting for the scroll handler reads as the click having missed.
      setActive(index);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToEvent(index);
      });
    });

    /* --- Loop ------------------------------------------------------------ */

    var ticking = false;

    function update() {
      updateReveal();
      updateRail();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Collages have no laid-out height until they load, so re-measure after.
    window.addEventListener('load', onScroll);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-ao-timeline]').forEach(function (root) {
      initTimeline(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ao-timeline]');
    if (root) initTimeline(root);
  });
})();
